export default "__VITE_ASSET__3d917cc5__"